import { el } from 'redom';

import DialogHeader from 'generics/components/dialog-section-header/native';
import BankAccountVerifierContent from './content';

import './index.scss';

class BankAccountVerifier {

  constructor(configuration, dialogConfiguration) {

    this.el = el('#bank-account-verifier-main', [
      new DialogHeader({ headerText: 'Action required', onClose: dialogConfiguration.onClose }),
      new BankAccountVerifierContent(configuration)
    ]);

  }

}

export default BankAccountVerifier;